document.addEventListener("DOMContentLoaded", function () {

  const form = document.getElementById("ld-lead");
  if (!form) return;

  const firstNameInput = document.getElementById("first_name");
  const lastNameInput = document.getElementById("last_name");
  const emailInput = document.getElementById("email");
  const primaryPhoneInput = document.getElementById("primary_phone");
  const submitButton = document.getElementById("submit_button");

  // Phone number formatting
  primaryPhoneInput.addEventListener("input", function (event) {
    let formattedValue = event.target.value;
    let unformattedValue = formattedValue.replace(/\D/g, "");

    const formattedPhoneNumber = unformattedValue.replace(
      /(\d{3})(\d{3})(\d{4})/,
      "($1) $2-$3"
    );

    event.target.value = formattedPhoneNumber;
    document.getElementById("primary-phone-unformatted").value = unformattedValue;
  });

  // Validation on blur
  firstNameInput.addEventListener("blur", validateFirstName);
  lastNameInput.addEventListener("blur", validateLastName);
  emailInput.addEventListener("blur", validateEmail);
  primaryPhoneInput.addEventListener("blur", validatePrimaryPhone);

  function validateFirstName() {
    const firstName = firstNameInput.value.trim();
    const firstNameError = document.getElementById("fname-error");
    const firstNameContainer = firstNameInput.closest(".form-item");
    if (firstName === "") {
      firstNameError.textContent = "First name is required.";
      submitButton.disabled = true;
      firstNameContainer.classList.add("form-error");
    } else if (/\d/.test(firstName)) {
      firstNameError.textContent = "First name cannot contain numbers.";
      submitButton.disabled = true;
      firstNameContainer.classList.add("form-error");
    } else {
      firstNameError.textContent = "";
      firstNameContainer.classList.remove("form-error");
      enableSubmitButtonIfValid();
    }
  }

  function validateLastName() {
    const lastName = lastNameInput.value.trim();
    const lastNameError = document.getElementById("lname-error");
    const lastNameContainer = lastNameInput.closest(".form-item");
    if (lastName === "") {
      lastNameError.textContent = "Last name is required.";
      submitButton.disabled = true;
      lastNameContainer.classList.add("form-error");
    } else if (/\d/.test(lastName)) {
      lastNameError.textContent = "Last name cannot contain numbers.";
      submitButton.disabled = true;
      lastNameContainer.classList.add("form-error");
    } else {
      lastNameError.textContent = "";
      lastNameContainer.classList.remove("form-error");
      enableSubmitButtonIfValid();
    }
  }

  function validateEmail() {
    const email = emailInput.value.trim();
    const emailError = document.getElementById("email-error");
    const emailContainer = emailInput.closest(".form-item");
    if (email === "") {
      emailError.textContent = "Email is required.";
      submitButton.disabled = true;
      emailContainer.classList.add("form-error");
    } else if (!isValidEmail(email)) {
      emailError.textContent = "Enter a valid email.";
      submitButton.disabled = true;
      emailContainer.classList.add("form-error");
    } else {
      emailError.textContent = "";
      emailContainer.classList.remove("form-error");
      enableSubmitButtonIfValid();
    }
  }

  function validatePrimaryPhone() {
    const primaryPhone = primaryPhoneInput.value.trim();
    const primaryPhoneError = document.getElementById("primary-phone-error");
    const primaryPhoneContainer = primaryPhoneInput.closest(".form-item");
    if (primaryPhone === "") {
      primaryPhoneError.textContent = "Phone number is required.";
      submitButton.disabled = true;
      primaryPhoneContainer.classList.add("form-error");
    } else if (!isValidPhone(primaryPhone)) {
      primaryPhoneError.textContent = "Enter a valid phone number.";
      submitButton.disabled = true;
      primaryPhoneContainer.classList.add("form-error");
    } else {
      primaryPhoneError.textContent = "";
      primaryPhoneContainer.classList.remove("form-error");
      enableSubmitButtonIfValid();
    }
  }

  function enableSubmitButtonIfValid() {
    if (
      firstNameInput.value.trim() !== "" &&
      !/\d/.test(firstNameInput.value.trim()) &&
      lastNameInput.value.trim() !== "" &&
      !/\d/.test(lastNameInput.value.trim()) &&
      emailInput.value.trim() !== "" &&
      isValidEmail(emailInput.value.trim()) &&
      primaryPhoneInput.value.trim() !== "" &&
      isValidPhone(primaryPhoneInput.value.trim())
    ) {
      submitButton.disabled = false;
    }
  }

  function isValidEmail(email) {
    const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,}$/;
    return emailRegex.test(email);
  }

  function isValidPhone(phone) {
    const phoneRegex = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
    return phoneRegex.test(phone);
  }
});
